/** Use on `<Navbar />` when nested under `[data-cleaner-turnover-chrome="1"]` so `--pv-*` tokens resolve. */
export const TURNOVER_RUNNER_NAVBAR_CLASSNAME =
  "border-[color:var(--pv-line)] !bg-[color-mix(in_srgb,var(--pv-surface)_88%,transparent)] backdrop-blur-md supports-[backdrop-filter]:!bg-[color-mix(in_srgb,var(--pv-surface)_72%,transparent)]";

/** In-progress job: hide Jobs/Profile so they cannot leave mid-step. */
export function isCleanerJobRunnerPath(pathname: string): boolean {
  return (
    pathname.startsWith("/clean/") ||
    pathname.startsWith("/tasks/run/") ||
    pathname.startsWith("/c/")
  );
}

/**
 * Jobs/Profile bar: `h-16` + `safe-area-bottom`.
 * Use only on screens that still show CleanerBottomNav (not the job runner).
 */
export const CLEANER_BOTTOM_NAV_HEIGHT =
  "calc(4rem + env(safe-area-inset-bottom, 0px))";

/** Sticky CTAs on the job runner sit on the home indicator, not above a nav bar. */
export const CLEANER_MOBILE_BOTTOM_NAV_OFFSET = "max-md:bottom-0";

/** Scroll padding when a fixed embed footer is visible (pre-visit steps). */
export const CLEANER_MOBILE_EMBED_FOOTER_SCROLL_PAD =
  "max-md:pb-[calc(7rem+env(safe-area-inset-bottom,0px))] md:pb-6";

/** Full-bleed simple job step shell. */
export const CLEANER_SIMPLE_STEP_SHELL =
  "flex h-[100dvh] max-h-[100dvh] w-full flex-col overflow-hidden bg-white";

/** Pre-start / min-height shells. */
export const CLEANER_SIMPLE_STEP_SHELL_MIN =
  "flex min-h-[100dvh] w-full flex-col bg-white";

/** Footer under primary Start/Next CTAs — sits on the home indicator. */
export const CLEANER_SIMPLE_CTA_FOOTER =
  "shrink-0 px-5 pb-[max(1.25rem,env(safe-area-inset-bottom))] pt-4";
